import {
    el, mount, setChildren, unmount
} from 'redom';
import * as QRCode from 'qrcode';

import { CROSS_ICON } from './icons';
import { IModelLink } from '../Viewer/interface';

/**
//! Liste des apareil Androïd compatible
// https://developers.google.com/ar/devices
*/

export class UiArQrCode {
    container: HTMLElement

    constructor(container: HTMLElement) {
        this.container = container;
        this.build();
    }

    private arLayerStyle = {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: 'calc(100% - 40px)',
        height: 'calc(100% - 40px)',
        background: 'rgba(0,0,0,0.6)',
        color: 'white',
        'z-index': 1000000000,
        padding: '20px'
    }

    private arCenterStyle = {
        position: 'relative',
        left: '50%',
        top: '50%',
        width: '540px',
        'max-width': 'calc(80% - 20px)',
        'text-align': 'center',
        transform: 'translate(-50%, -50%)',
        'background-color': 'white',
        color: 'black',
        'border-radius': '20px',
        padding: '40px',
        'font-size': '18px',
        'font-family': 'Helvetica',
    }

    private arExitButtonStyle = {
        position: 'absolute',
        cursor: 'pointer',
        top: '20px',
        right: '20px',
        'box-sizing': 'content-box'
    }

    private layer: HTMLElement

    private addLayer(callback?: () => void): HTMLElement {
        let exit: HTMLElement;
        let containerLayer: HTMLElement;
        this.layer = el('div',
            {
                style: this.arLayerStyle,
            },
            [
                el('div', { style: this.arCenterStyle }, [
                    exit = el('div', { style: this.arExitButtonStyle }),
                    containerLayer = el('div')
                ]),
            ]);
        this.layer.addEventListener('click', () => {
            if (callback) callback();
            unmount(this.container, this.layer);
        });
        exit.innerHTML = CROSS_ICON.replaceAll('20px', '30px');
        return containerLayer;
    }

    private canvas: HTMLCanvasElement

    public build(): void {
        const layer = this.addLayer();
        const containerWidth = this.container.getBoundingClientRect().width;
        const children = [
            el('div', { style: { 'font-size': '18px', paddingBottom: '20px', 'text-transform': 'uppercase' } },
                'Discover the product in Augmented Reality'),
            el('div', { style: { 'font-size': '12px', color: 'rgb(100,100,100)', paddingBottom: '20px' } },
                'Supported devices: Minimum iPhone 6S & iPad 5 on iOS 12 and Android 8.0 with ARCore 1.9 support'),
            el('div', { style: { display: 'flex' } }, [
                containerWidth > 500
                    ? el('div',
                        el('img', {
                            src: 'https://d23jutsnau9x47.cloudfront.net/studio/images/AR.jpeg',
                            style: {
                                width: '100%',
                                top: '50%',
                                position: 'relative',
                                transform: 'translateY(-50%)',
                                'border-radius': '10px'
                            }
                        })) : null,
                el('div', { style: { 'padding-left': '20px' } }, [
                    el('div', { style: { 'font-size': '12px', 'font-weight': '800', 'text-transform': 'uppercase' } },
                        'Scan this QRCode on a mobile or tablet'),
                    this.canvas = el('canvas'),
                ]),

            ]),
        ];
        setChildren(layer, children);
    }

    private show() {
        mount(this.container, this.layer);
    }

    private getARUrl(projectId: string, modelLink?: IModelLink): string {
        // Do not use href url as this is the current website and not the 3D experience link
        // QRCode.toCanvas(canvas, `${window.location.href}?AR=true`);
        let ARUrl = `https://harbor.naker.io/studio/${projectId}?AR=true`;
        if (modelLink) {
            const { glb, usdz } = modelLink;
            const glbUrl = encodeURIComponent(glb);
            ARUrl += `&glbUrl=${glbUrl}`;

            const glbWithoutExt = glb.split('.glb')[0]
            const usdzWithoutExt = usdz.split('.usdz')[0]
            if (usdz && glbWithoutExt !== usdzWithoutExt) {
                const usdzUrl = encodeURIComponent(usdz);
                ARUrl += `&usdzUrl=${usdzUrl}`;
            }
        }
        return ARUrl;
    }

    public setQRCoreModelLink(projectId: string, modelLink?: IModelLink): void {
        let ARUrl = this.getARUrl(projectId, modelLink)
        this.setQRCodeUrl(ARUrl);
        this.show();
    }

    public getQRCodeCanvas(projectId: string, modelLink?: IModelLink): HTMLCanvasElement {
        let ARUrl = this.getARUrl(projectId, modelLink)
        let canvas = el('canvas');
        QRCode.toCanvas(canvas, ARUrl);
        return canvas
    }

    public setQRCodeUrl(url: string): void {
        this.show();
        QRCode.toCanvas(this.canvas, url);
    }
}
